import React from "react";
import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
// import "react-toastify/ReactToastify.css";

const Toast = (message, type,autoClose) => {
  switch (type) {
    case "success":
      return toast.success(message, { autoClose: autoClose|| 1000 });
    case "error":
      return toast.error(message, { autoClose: autoClose|| 1000 });
    case "warning":
      return toast.warning(message, { autoClose:autoClose|| 1000 });
    case "info":
      return toast.info(message, { autoClose: autoClose||1000 });
    default:
      return toast.warning(message, { autoClose:autoClose|| 1000 });
  }
};
export default Toast;
